import React, { Component } from 'react';
import { fromJS, toJS, is } from 'immutable';

export default class PicabooComponentBase extends Component {
  constructor(props) {
    super(props);
    this.ignoreOnUpdate = [];
  }

  shouldComponentUpdate(nextProps, nextState) {
    let shouldUpdate = false;

    let failedProps = [];
    let failedState = [];

    if (this.props) {
      Object.keys(this.props).forEach(
        function (prop) {
          if (this.ignoreOnUpdate.includes(prop)) {
            return;
          }
          const value =
            this.props[prop] != null &&
            this.props[prop] != [] &&
            this.props[prop].toJS != 'undefined'
              ? !is(this.props[prop], nextProps[prop])
              : !is(fromJS(this.props[prop]), fromJS(nextProps[prop]));
          if (value) {
            failedProps.push(prop);
          }
          shouldUpdate = shouldUpdate || value;
        }.bind(this),
      );
    }
    if (this.state) {
      Object.keys(this.state).forEach(
        function (state) {
          if (this.ignoreOnUpdate.includes(state)) {
            return;
          }
          const value =
            this.state[state] != null && this.state[state].toJS != 'undefined'
              ? !is(this.state[state], nextState[state])
              : !is(fromJS(this.state[state]), fromJS(nextState[state]));
          if (value) {
            failedState.push(state);
          }
          shouldUpdate = shouldUpdate || value;
        }.bind(this),
      );
    }

    //uncomment here to see what properties are causing a component to update.
    // if(shouldUpdate){
    //     console.debug(shouldUpdate, this.constructor.name, failedProps, failedState);
    // }

    return shouldUpdate;
  }

  pagesAreEqual(oldPages, newPages) {
    if (
      oldPages === undefined ||
      newPages === undefined ||
      oldPages.count() !== newPages.count()
    ) {
      return false;
    }
    const oldPagesKeys = Object.keys(oldPages.toJS());
    const newPagesKeys = Object.keys(newPages.toJS());

    let pagesAreEqual = true;
    for (let i = 0; i < oldPages.count(); ++i) {
      pagesAreEqual =
        pagesAreEqual &&
        this.pageIsEqual(
          oldPages.get(oldPagesKeys[i]),
          newPages.get(newPagesKeys[i]),
        );
    }
    return pagesAreEqual;
  }

  pageIsEqual(oldPage, newPage) {
    if (!oldPage || !newPage) {
      return false;
    }
    const keysToCheck = [
      'background',
      'currentLayout',
      'id',
      'layoutLocked',
      'pageItems',
      'pageNumber',
      'ratio',
      'ratioBase',
    ];
    return keysToCheck.reduce((value, currentItem) => {
      return value && is(oldPage.get(currentItem), newPage.get(currentItem));
    }, true);
  }
}
